import { PhoneNumberUtil } from 'google-libphonenumber';
import moment from 'moment-timezone';

export const valid = {
  isValidPhoneNumber: (phoneNumber: string): boolean => {
    if (!phoneNumber) return true;
    try {
      const phoneUtil = PhoneNumberUtil.getInstance();
      const number = phoneUtil.parseAndKeepRawInput(phoneNumber);
      const isPossible = phoneUtil.isPossibleNumber(number);
      if (isPossible) {
        return phoneUtil.isValidNumber(number) || phoneUtil.getNumberType(number) === 0;
      }
      return false;
    } catch (e) {
      return false;
    }
  },

  isValidEmail: (email: string): boolean => {
    const regEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regEx.test(email);
  },

  isPasswordValid: (password: string): boolean => {
    if (password === '') return true;
    const passw = /((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z])(?=.{8,}).*$/;
    return password.match(passw) !== null;
  },

  matchPassword: (newPassword: string, passwordConfirmation: string): boolean => {
    return passwordConfirmation === newPassword;
  },

  isDateValid: (start: any, end: any): boolean => {
    if (!start && !end) return true;
    const startDate = moment(start);
    const endDate = moment(end);
    return endDate.diff(startDate) >= 0;
  },

  isTimeValid: (start: any, end: any): boolean => {
    if (!start || !end) return true;
    const startDate = moment(start);
    const endDate = moment(end);
    return endDate.diff(startDate, 'seconds') > 0;
  },
};
